import {UyapRequest} from "./UyapRequest";
import {ISorguSonuc} from "./CommonInterfaces";
import app from "@/main";

export interface DosyaBorcluMernisTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
}

export interface DosyaBorcluMernisCevap extends ISorguSonuc<IBorcluMernisSonuc> {}

export interface IBorcluMernisSonuc {
    kimlikBilgisi: Array<IKimlikBilgisi>,
    mernisAdres: IMernisAdres
}

export interface IKimlikBilgisi {
    olumKaydi: boolean,
    isAvukat: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    isHakimSavci: boolean,
    mernisDegisiklikVarmi: boolean,
    mernisDegisiklikNedeni: string,
    nufusaKayitIlKodu: number,
    nufusaKayitIlceKodu: number,
    mahKoy: string,
    ciltNo: string,
    aileSiraNo: string,
    siraNo: string,
    cuzdanSeriNo: string,
    verildigiIlKodu: number,
    verildigiIlceKodu: number,
    verildigiIlAdi: string,
    dinAciklamasi: string,
    sorguTuru: number,
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    babaAdi: string,
    anaAdi: string,
    dogumTarihiStr: string,
    cinsiyeti: string,
    medeniHali: number,
    dini: string,
    dogumYeri: string,
    nufusaKayitliIlAdi: string,
    nufusaKayitliIlceAdi: string,
    aktifMernisAdresiSorgusu: boolean,
    hasOlumKaydi: boolean
}

export interface IMernisAdres {
    TCKimlikNo: number,
    adresler: Array<Adresler>
}

interface Adresler {
    AdresTipi: string,
    adresNo: number,
    ilIlceMerkeziAdresi?: IlIlceMerkeziAdresi,
    beyandaBulunanTCKimlikNo: number,
    tescilTarih?: ITarih,
    beyanTarih?: ITarih,
    tasinmaTarih?: ITarih
}

interface IlIlceMerkeziAdresi {
    ilKodu: number,
    uyapIlKodu: number,
    il: string,
    ilceKodu: number,
    uyapIlceKodu: number,
    icKapiNo?: string,
    ilce: string,
    mahalleKod: number,
    mahalle: string,
    csbmKodu: number,
    csbm: string,
    disKapiNo: string
}

interface ITarih {
    yil: number,
    ay: number,
    gun: number
}

export default class DosyaBorcluMernis extends UyapRequest<DosyaBorcluMernisTalep, DosyaBorcluMernisCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu MERNİS bilgileri sorgulanıyor...";
    }

    /**
     * Snapshot deposundaki alan adı (picker `name`). Taze kayıtta ham gövde
     * varsa okunur (B1: `zincireGirer` erken elemesi kaldırıldı); kurucu
     * yedeği (gövdesiz eski kayıtlar için) bu alanı kapsamıyor — canlı
     * tüketen ekran yok ve sorgu ücretsiz (kazanç sıfır).
     */
    protected snapshotAlani(): string | null {
        return "mernis";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "DosyaBorcluMernis_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IoF55CvhL24jO5Gr43Jg91aDFoPjZaGQ9ujeUxmcSB7C","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 11:37","sorguSonucDVO":{"kimlikBilgisi":[{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","nufusaKayitIlKodu":58,"nufusaKayitIlceKodu":1,"mahKoy":"ÖRTÜLÜPINAR","ciltNo":"28","aileSiraNo":"189","siraNo":"28","cuzdanSeriNo":"A11L79692","verildigiIlKodu":99,"verildigiIlceKodu":0,"verildigiIlAdi":"Bilinmiyor","dinAciklamasi":"Bilinmeyen","sorguTuru":0,"tcKimlikNo":"47161224210","adi":"AHMETİ MÜNÜR","soyadi":"YALÇINALP","babaAdi":"ABDULKADİR","anaAdi":"ŞADİYE","dogumTarihiStr":"25/08/1957","cinsiyeti":"E","medeniHali":3,"dini":"DINTR00009","dogumYeri":"SİVAS","nufusaKayitliIlAdi":"Sivas","nufusaKayitliIlceAdi":"Sivas Merkez","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false}],"mernisAdres":{"TCKimlikNo":47161224210,"adresler":[{"AdresTipi":"IlIlceMerkeziAdresi","adresNo":3227821786,"ilIlceMerkeziAdresi":{"ilKodu":6,"uyapIlKodu":6,"il":"ANKARA","ilceKodu":1723,"uyapIlceKodu":25,"ilce":"YENİMAHALLE","mahalleKod":1860,"mahalle":"DEMETLALE MAH.","csbmKodu":58597,"csbm":"405 CAD.","disKapiNo":"77C"},"beyandaBulunanTCKimlikNo":0,"tescilTarih":{"yil":2023,"ay":12,"gun":13},"beyanTarih":{"yil":2023,"ay":12,"gun":13},"tasinmaTarih":{"yil":2023,"ay":12,"gun":6}}]}},"sorgulamaTuru":"Mernis","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false}
        // bilinmiyor
        // return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"1********64","adi":"HA***","soyadi":"YÜ**","babaAdi":"K*******","anaAdi":"T*****","dogumTarihiStr":"1980","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":30578168,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 5. Genel İcra Dairesi","birimId":"1000950","orgKodu":"1.04.011.000.6040","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6040","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2013/13966","dosyaNoYil":2013,"dosyaSira":13966,"dosyaId":"SCsGSFWmfdGXCX1foQd1V+TMLSLKbKIGicvhof44O1Kgiq1BKcgyLk@UpB0T0@93","dosyaAcilisTarihi":"27/08/2013 10:39","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"HASAN YÜCE","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"20/05/2024 14:11","sorguSonucDVO":{"kimlikBilgisi":[{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","nufusaKayitIlKodu":1,"nufusaKayitIlceKodu":8,"mahKoy":"ÇOBANPINARI","ciltNo":"30","aileSiraNo":"34","siraNo":"55","cuzdanSeriNo":"A06E04769","verildigiIlKodu":99,"verildigiIlceKodu":0,"verildigiIlAdi":"Bilinmiyor","dinAciklamasi":"Bilinmeyen","sorguTuru":0,"tcKimlikNo":"16498184764","adi":"HASAN","soyadi":"YÜCE","babaAdi":"KURTARAN","anaAdi":"TÜRKAN","dogumTarihiStr":"14/04/1980","cinsiyeti":"E","medeniHali":1,"dini":"DINTR00009","dogumYeri":"ADANA","nufusaKayitliIlAdi":"Adana","nufusaKayitliIlceAdi":"Kozan","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false}],"mernisAdres":{"TCKimlikNo":16498184764,"adresler":[{"AdresTipi":"Bilinmiyor","adresNo":0,"beyandaBulunanTCKimlikNo":0}]}},"sorgulamaTuru":"Mernis","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_mernis.ajx';
    }

    async parse(data: DosyaBorcluMernisCevap): Promise<DosyaBorcluMernisCevap> {
        data.message = "Mernis adresi bulundu.";
        if (data.sorguSonucDVO?.mernisAdres.adresler[0].AdresTipi == "Bilinmiyor")
            data.message = "Mernis adresi bilinmiyor."
        return data;
    }
}